import  routesConfig from './routesConfig';
import Permissions from './permissions';

export default {
    menus: [
        {
            key: " dashboard",
            title: 'Dashboard',
            permissions: [],
            route:null,
            iconClass : "ion ion-ios-home-outline",
            subMenus: null

        },
        {
            key: "disputeManagement",
            title: "Dispute Management",
            permissions: [Permissions.VIEW_DISPUTE],
            route: null,
            iconClass : "ion ion-ios-briefcase-outline",
            subMenus: [
                {
                    key: "newClaim",
                    title: "New Claim",
                    permissions: [Permissions.CREATE_DISPUTE],
                    route: routesConfig.NEW_CLAIM_ROUTE
                },
                {
                    key: "dispute",
                    title: "Disputes",
                    permissions: [Permissions.VIEW_DISPUTE],
                    route: routesConfig.DISPUTES_ROUTE
                },
                {
                    key: "bulkDisputes",
                    title: "Dispute Batches",
                    permissions: [Permissions.CREATE_DISPUTE, Permissions.VIEW_DISPUTE],
                    route: routesConfig.BULK_DISPUTES_ROUTE
                }
            ]
        },
        {
            key : "administration",
            title : "Administration",
            permissions: [
                Permissions.UPDATE_SCRIPT, 
                Permissions.VIEW_REASON_CODE, 
                Permissions.VIEW_DISPUTE_REGION,
                Permissions.VIEW_TRANSACTION_GROUP,
                Permissions.VIEW_TRANSACTION_TYPE, 
                Permissions.VIEW_TRANSACTION_TIMELINE,
                Permissions.VIEW_DISPUTE_TIMELINE,
                Permissions.VIEW_MERCHANT_DISPUTANT],
            route: null,
            iconClass : "ion ion-ios-cog-outline",
            subMenus : [
                 {
                    key: "disputeRegions",
                    title: "Dispute Regions",
                    permissions: [Permissions.VIEW_DISPUTE_REGION],
                    route: routesConfig.DISPUTE_REGIONS_ROUTE
                },
                {
                    key: "disputeTimelines",
                    title: "Dispute Timelines",
                    permissions: [Permissions.VIEW_DISPUTE_TIMELINE],
                    route: routesConfig.DISPUTE_TIMELINE_ROUTE
                },

                {
                    key: "merchantDisputants",
                    title: "Merchant Disputants",
                    permissions: [Permissions.VIEW_MERCHANT_DISPUTANT],
                    route: routesConfig.MERCHANT_DISPUTANT_ROUTE
                },
                
                {
                    key: "reasonCodes",
                    title: "Reason Codes",
                    permissions: [Permissions.VIEW_REASON_CODE],
                    route: routesConfig.REASON_CODES_ROUTE
                },
                {
                    key: "scripts",
                    title: "Scripts",
                    permissions: [Permissions.UPDATE_SCRIPT],
                    route: routesConfig.SCRIPTS_ROUTE
                },
                {
                    key: "transactionGroups",
                    title: "Transaction Groups",
                    permissions: [Permissions.VIEW_TRANSACTION_GROUP],
                    route: routesConfig.TRANSACTION_GROUPS_ROUTE
                },
                {
                    key: "transactionTimelines",
                    title: "Transaction Timelines",
                    permissions: [Permissions.VIEW_TRANSACTION_TIMELINE],
                    route: routesConfig.TRANSACTION_TIMELINE_ROUTE
                },
                {
                    key: "transactionTypes",
                    title: "Transaction Types",
                    permissions: [Permissions.VIEW_TRANSACTION_TYPE],
                    route: routesConfig.TRANSACTION_TYPES_ROUTE
                },
            ]


        }
    ]
}


// WEBPACK FOOTER //
// ./src/configurations/menuConfig.js